// TableBottomBar.tsx — generische Bottom-Leiste für die Redesign-Tabellen.
// Wird NUR angezeigt, wenn etwas ausgewählt ODER gefiltert ist. Zeigt links die
// Zähler (Auswahl / gefilterte Gesamtzahl) und rechts einen `actions`-Slot
// (z.B. Löschen — vom Consumer, gated). Sitzt als nicht-scrollender Flex-Child
// am unteren Rand der Tabellen-Seite (siehe .kvp-rd-table-page in der CSS).

import * as React from "react";

export function TableBottomBar({
  selectionCount = 0,
  filteredTotal,
  filterActive = false,
  actions,
}: {
  selectionCount?: number;
  /** Gefilterte Gesamtzahl (z.B. aus X-Total-Count). */
  filteredTotal?: number | null;
  /** Ob mind. ein Filter aktiv ist (steuert Sichtbarkeit + „gefiltert"-Anzeige). */
  filterActive?: boolean;
  actions?: React.ReactNode;
}) {
  const visible = selectionCount > 0 || filterActive;
  if (!visible) return null;

  return (
    <div className="tbar-bottom" role="status">
      <div className="tbar-counts">
        {selectionCount > 0 && (
          <span className="tbar-chip">
            <strong>{selectionCount}</strong> ausgewählt
          </span>
        )}
        {filterActive && (
          <span className="tbar-chip muted">
            {filteredTotal != null ? <><strong>{filteredTotal}</strong> gefiltert</> : "gefiltert"}
          </span>
        )}
      </div>
      {actions ? <div className="tbar-actions">{actions}</div> : null}
    </div>
  );
}
